(function () {
  'use strict';

  function initDetailView() {
    var grid = document.querySelector('[data-detail-grid]');
    if (!grid) return;

    // 미디어쿼리: PC 전용 (769px 이상)
    var mq = window.matchMedia('(min-width: 769px)');
    if (!mq.matches) return;

    var items = grid.querySelectorAll('[data-detail-item]');
    if (!items.length) return;

    function activate(targetItem) {
      items.forEach(function (item) {
        item.classList.remove('is-active');
      });
      targetItem.classList.add('is-active');
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        activate(item);
      });
    });

    // 초기값: 첫 번째 활성 (Liquid에서 이미 클래스 부여했으나 JS로도 보장)
    if (!grid.querySelector('.is-active')) {
      activate(items[0]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDetailView);
  } else {
    initDetailView();
  }
})();
